import template from './templates/checkout-applied-promo';
import store from '@stores/cart/cart-store';

const CLASS_NAME_BORDERED = '-bordered';

const DEFAULT_CONTEXT = {
    applied: 'Applied',
    remove: 'Remove Promo Code'
};

const DEFAULT_OPTIONS = {
    bordered: false,
    replaceOriginEl: false,
    removeable: true
};

export default class CheckoutAppliedPromo {
    constructor($originEl, context, options) {
        context = { ...DEFAULT_CONTEXT, ...context };
        options = { ...DEFAULT_OPTIONS, ...options };

        const $parsed = $( $.parseHTML(template));
        this.$el = $parsed;
        this.$originEl = $originEl;

        this.appliedLabel = this.$el.find('[data-label="applied"]');
        this.removeLabel = this.$el.find('[data-label="remove"]');

        this.$code = this.$el.find('[data-region="code"]');

        this.$removeCtrl = this.$el.find('[data-control="remove"]');

        this.context = context;
        Object.assign(this, options);

        this.init();
    }

    init() {
        this.renderLabels();
        this.toggleBordered();
        this.toggleRemove();
        this.updateCode();
        this.setupListeners();
    }

    async onRemove() {
        const { success, error } = await store.actions.removePromo();

        // todo: error handling
        console.log(success, error);
    }

    render() {
        if(this.$originEl) {
            this.replaceOriginEl ? this.$originEl.replaceWith(this.$el) : this.$originEl.html(this.$el);
        }

        return this.$el;
    }

    renderLabels() {
        this.appliedLabel.html(this.context.applied);
        this.removeLabel.html(this.context.remove);
    }

    toggleBordered() {
        if(this.bordered) {
            this.$el.addClass(CLASS_NAME_BORDERED);
        }
    }

    toggleRemove() {
        if(!this.removeable) {
            this.$removeCtrl.remove();
        }
    }

    setupListeners() {
        this.$removeCtrl.on('click', () => this.onRemove());

        store.watch('promoCode', () => this.updateCode());
    }

    updateCode() {
        this.$code.html(store.state.promoCode);
    }
};
